import React, { useState, useEffect } from 'react';
import "../AdminDashboard.css";
import "./Profile.css";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Card, Badge } from '../../../../ui';

function Profile() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!API_URL) {
                    setError('API URL not configured. Please check your environment variables.');
                    setLoading(false);
                    return;
                }

                const currentUser = JSON.parse(localStorage.getItem('user'));
                if (!currentUser || !currentUser._id) {
                    setError('User not found. Please log in again.');
                    setLoading(false);
                    return;
                }

                const response = await axios.get(`${API_URL}api/users/getuser/${currentUser._id}`);
                if (response.data) {
                    setUser(response.data);
                    setLoading(false);
                } else {
                    setError('No user data received from server.');
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error fetching user data:', err);
                const errorMessage = err.response?.data?.message || err.message || 'Failed to load profile data. Please try again later.';
                setError(errorMessage);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [API_URL]);

    if (loading) {
        return (
            <div className="admin-profile-loading">
                <CircularProgress />
                <p>Loading profile data...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Card padding="lg" className="admin-profile-error">
                <p>{error}</p>
            </Card>
        );
    }

    return (
        <div className="admin-profile-container">
            <h2 className="admin-profile-title">Admin Profile</h2>

            {user && (
                <Card padding="lg" className="admin-profile-card">
                    <div className="admin-profile-header">
                        <div className="admin-profile-avatar">
                            {user.photo ? (
                                <img src={user.photo} alt={user.userFullName} />
                            ) : (
                                <AccountCircleIcon style={{ fontSize: 80 }} />
                            )}
                        </div>
                        <div className="admin-profile-info">
                            <h3 className="admin-profile-name">{user.userFullName}</h3>
                            <Badge variant="primary" className="admin-profile-badge">
                                {user.userType?.toUpperCase() || 'ADMIN'}
                            </Badge>
                            {user.employeeId && (
                                <p className="admin-profile-id">{user.employeeId}</p>
                            )}
                        </div>
                    </div>

                    <div className="admin-profile-details">
                        <div className="admin-profile-grid">
                            <Card padding="md" className="admin-profile-info-card">
                                <span className="admin-profile-label">Email</span>
                                <span className="admin-profile-value">{user.email}</span>
                            </Card>
                            <Card padding="md" className="admin-profile-info-card">
                                <span className="admin-profile-label">Mobile Number</span>
                                <span className="admin-profile-value">{user.mobileNumber || 'N/A'}</span>
                            </Card>
                            <Card padding="md" className="admin-profile-info-card">
                                <span className="admin-profile-label">Department</span>
                                <span className="admin-profile-value">{user.department || 'N/A'}</span>
                            </Card>
                            <Card padding="md" className="admin-profile-info-card">
                                <span className="admin-profile-label">Designation</span>
                                <span className="admin-profile-value">{user.designation || 'N/A'}</span>
                            </Card>
                            <Card padding="md" className="admin-profile-info-card">
                                <span className="admin-profile-label">Address</span>
                                <span className="admin-profile-value">{user.address || 'N/A'}</span>
                            </Card>
                        </div>

                        {user.permissions && (
                            <div className="admin-profile-permissions">
                                <h4 className="admin-profile-section-title">Permissions</h4>
                                <div className="admin-profile-permissions-grid">
                                    <Card padding="md" className="admin-profile-permission-card">
                                        <div className={`admin-profile-permission-icon ${user.permissions?.canUploadPDF ? 'permission-enabled' : 'permission-disabled'}`}>
                                            {user.permissions?.canUploadPDF ? '✓' : '✗'}
                                        </div>
                                        <span className="admin-profile-permission-label">Upload PDF Books</span>
                                    </Card>
                                    <Card padding="md" className="admin-profile-permission-card">
                                        <div className={`admin-profile-permission-icon ${user.permissions?.canManageUsers ? 'permission-enabled' : 'permission-disabled'}`}>
                                            {user.permissions?.canManageUsers ? '✓' : '✗'}
                                        </div>
                                        <span className="admin-profile-permission-label">Manage Users</span>
                                    </Card>
                                    <Card padding="md" className="admin-profile-permission-card">
                                        <div className={`admin-profile-permission-icon ${user.permissions?.canManageBooks ? 'permission-enabled' : 'permission-disabled'}`}>
                                            {user.permissions?.canManageBooks ? '✓' : '✗'}
                                        </div>
                                        <span className="admin-profile-permission-label">Manage Books</span>
                                    </Card>
                                </div>
                            </div>
                        )}
                    </div>
                </Card>
            )}
        </div>
    );
}

export default Profile;
